import type { JSX } from 'react';
import { HandshakeIcon, MoneyBillWaveIcon } from '@c2fo/liquidity/icons';
import handPointer from '@/enterprise/assets/hand-pointer.svg?url';
import moneyShield from '@/enterprise/assets/money-shield.svg?url';
import { ACCELERATE_ADDITIONAL_RECEIVABLES_CONTENT } from '@/enterprise/features/extendedNetworkFinance/content/sharedContent';

const BENEFIT_ICONS: JSX.Element[] = [
  <MoneyBillWaveIcon key="money-bill" className="h-9 w-9 fill-text-secondary" aria-hidden />,
  <HandshakeIcon key="handshake" className="h-9 w-9 fill-text-secondary" aria-hidden />,
  <img key="hand-pointer" src={handPointer} alt="" className="h-9 w-9 object-contain" />,
];

const AccelerateAdditionalReceivables = (): JSX.Element => (
  <div className="space-y-6">
    <div className="space-y-4 text-center">
      <p className="text-3xl">{ACCELERATE_ADDITIONAL_RECEIVABLES_CONTENT.title}</p>
      <p className="mx-auto max-w-6xl text-lg">{ACCELERATE_ADDITIONAL_RECEIVABLES_CONTENT.intro}</p>
    </div>

    <div className="space-y-6 rounded-xl bg-white p-6 shadow-sm">
      <div className="flex flex-col items-center space-y-4 rounded-lg bg-primary-100 p-6 text-center">
        <img src={moneyShield} alt="" className="h-14 w-14 object-contain" />
        <p className="text-2xl font-bold">{ACCELERATE_ADDITIONAL_RECEIVABLES_CONTENT.trustBanner.title}</p>
        <p className="text-base">{ACCELERATE_ADDITIONAL_RECEIVABLES_CONTENT.trustBanner.description}</p>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {ACCELERATE_ADDITIONAL_RECEIVABLES_CONTENT.benefits.map((benefit, index) => (
          <div
            key={benefit.title}
            className="flex flex-col items-center justify-center space-y-4 rounded-lg border border-deepGray-500/30 p-4 text-center"
          >
            {BENEFIT_ICONS[index]}
            <div className="space-y-2">
              <p className="text-lg font-medium">{benefit.title}</p>
              <p className="text-base text-text-secondary">{benefit.description}</p>
            </div>
          </div>
        ))}
      </div>

      <p className="text-center text-xs italic text-text-secondary">
        {ACCELERATE_ADDITIONAL_RECEIVABLES_CONTENT.benefitsFootnote}
      </p>
    </div>
  </div>
);

export default AccelerateAdditionalReceivables;
